<template>
  <div class="right--chart_3">
    <h3 class="right--chart_3_title">
      {{ this.params.hxcs_position }}部位检查医院使用品牌列表
    </h3>
    <dv-scroll-board class="right--scroll" :config="dataConfig" />
  </div>
</template>

<script>
import { selectInspectBrand } from '@/api/modules/dataView.js'
export default {
  name: 'RightChart3',
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
          hxcs_position: '',
        }
      },
    },
  },
  data() {
    return {
      dataConfig: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      selectInspectBrand(this.params).then(data => {
        let tableData = []
        if (data) {
          data.forEach(item => {
            tableData.push([
              item.org_name || '',
              item.brand_one || '',
              item.brand_two || '',
            ])
          })
        }
        this.dataConfig = {
          rowNum: 10,
          header: ['医院', '品牌1', '品牌2'],
          data: tableData,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.right--chart_3 {
  width: 100%;
  height: 43%;
  display: flex;
  flex-direction: column;
  .right--chart_3_title {
    text-align: center;
    line-height: 50px;
  }
  .right--scroll {
    flex: 1;
  }
}
</style>
